export const ROLE_LABELS = {
  SUPER_ADMIN: "Super Admin",
  ADMIN: "Admin",
  COACH: "Coach",
  CUSTOMER: "Member",
};

export const STAGE_META = {
  NEW: { label: "New Lead", color: "#A1A1AA" },
  CONTACTED: { label: "Contacted", color: "#7DD3FC" },
  CONSULTATION_BOOKED: { label: "Consultation Booked", color: "#22D3EE" },
  TRIAL_COMPLETED: { label: "Consultation Done", color: "#A78BFA" },
  PROPOSAL_SENT: { label: "Proposal", color: "#FBBF24" },
  WON: { label: "Won", color: "#00E676" },
  LOST: { label: "Lost", color: "#FF3B30" },
  OVERDUE_30: { label: "Overdue > 30", color: "#F97316" },
  OVERDUE_60: { label: "Overdue > 60", color: "#DC2626" },
  DROPPED_OUT: { label: "Dropped Out", color: "#F59E0B" },
};

// Per-pipeline column order. The "ALL" view falls back to the LEAD list plus
// the renewal-only stages tacked on the end, so no card is ever orphaned.
export const NEW_LEAD_STAGES = [
  "NEW", "CONTACTED", "CONSULTATION_BOOKED", "TRIAL_COMPLETED",
  "PROPOSAL_SENT", "WON", "LOST",
];
export const RENEWAL_STAGES = [
  "NEW", "CONTACTED", "PROPOSAL_SENT", "WON",
  "OVERDUE_30", "OVERDUE_60", "DROPPED_OUT",
];
export const STAGES = [
  "NEW", "CONTACTED", "CONSULTATION_BOOKED", "TRIAL_COMPLETED",
  "PROPOSAL_SENT", "WON", "LOST",
  "OVERDUE_30", "OVERDUE_60", "DROPPED_OUT",
];

// Weighted-pipeline probabilities. Multiply a lead's budget (or a renewal's
// expected amount) by the current stage's factor to get its forecast value.
// LOST and DROPPED_OUT are 0 so they drop out of the sum automatically.
export const STAGE_PROBABILITY = {
  NEW: 0.10,
  CONTACTED: 0.20,
  CONSULTATION_BOOKED: 0.35,
  TRIAL_COMPLETED: 0.55,
  PROPOSAL_SENT: 0.65,
  WON: 1.00,
  LOST: 0.00,
  OVERDUE_30: 0.30,
  OVERDUE_60: 0.15,
  DROPPED_OUT: 0.00,
};

export const SOURCE_LABEL = {
  WEBSITE: "Website",
  WEBSITE_FORM: "Website Form",
  WALK_IN: "Walk-in",
  REFERRAL: "Referral",
  INSTAGRAM: "Instagram",
  WHATSAPP: "WhatsApp",
  GOOGLE_BUSINESS: "Google Business",
  EVENTS: "Events",
  CORPORATE: "Corporate",
  RENEWAL: "Renewal",
};

export const CATEGORY_LABEL = {
  OPEN_GYM: "Open Gym",
  GROUP_TRAINING: "Group Training",
  SEMI_PT: "Semi PT",
  PT: "Personal Training",
  RECOVERY: "Recovery",
};

export const SESSION_TYPES = ["HYROX", "MMA", "STRENGTH", "HYROX_MMA", "HYROX_STRENGTH", "STRENGTH_MMA", "PT", "SEMI_PT"];

export const SESSION_TYPE_LABEL = {
  HYROX: "Hyrox",
  MMA: "MMA",
  STRENGTH: "Strength & Conditioning",
  HYROX_MMA: "Hyrox + MMA",
  HYROX_STRENGTH: "Hyrox + Strength",
  STRENGTH_MMA: "Strength + MMA",
  PT: "Personal Training",
  SEMI_PT: "Semi PT (≤5 members)",
  OPEN_GYM: "Open Gym",
  CONDITIONING: "Conditioning",
};

export const SPECIALIZATION_LABEL = {
  HYROX: "Hyrox",
  MMA: "MMA",
  STRENGTH: "Strength & Conditioning",
};

export const SPECIALIZATION_COLOR = {
  HYROX: "#FFEA00",
  MMA: "#FF3B30",
  STRENGTH: "#CCFF00",
};

export const INR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);
